'use client';

import { FormattedMessage } from '@flipster/i18n';
import { useOverlay } from '@flipster/overlay';
import { Button } from '@flipster/react/design-system/button';
import { IconButton } from '@flipster/react/design-system/icon-button';
import QrCodeIcon from '@flipster/react/icon/generated/QrCodeIcon';
import { hstack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import segment from '@flipster/utils/segment';
import { MainEvent } from '@flipster/utils/segment/events/main';

import { AppDownloadModal } from '@web/app/[locale]/(web)/_app-download/modal';

export const DownloadAppButton = () => {
  const overlay = useOverlay();

  const onClickDownloadApp = () => {
    segment.track(MainEvent.MainPageDownloadAppClick);
    overlay.open(({ isOpen, close, unmount }) => <AppDownloadModal isOpen={isOpen} onClose={close} onExit={unmount} />);
  };

  return (
    <>
      {/* > mobile */}
      <div
        className={hstack({
          display: { base: 'none', tablet: 'flex' },
          textStyle: 'Text/M/Strong',
          color: 'content.default.level-2',
          gap: 8,
        })}
      >
        <p>
          <FormattedMessage id='Common.r251104.Download_app' />
        </p>
        <IconButton
          hierarchy='tertiary'
          size='large'
          icon={<QrCodeIcon color={token('colors.content.default.level-5')} />}
          onClick={onClickDownloadApp}
        />
      </div>
      {/* = mobile */}
      <Button
        hierarchy='secondary'
        color='neutral'
        size='large'
        label={<FormattedMessage id='Common.r251104.Download_app' />}
        onClick={onClickDownloadApp}
        css={{ display: { tablet: 'none' }, w: '100%' }}
      />
    </>
  );
};
